{
  "title": "Sign in to Platko",
  "signInSubtitle": "Sign in to your account",
  "createAccountTitle": "Create an account",
  "createAccountSubtitle": "Create your account",
  "alreadyHaveAccount": "Already have an account?",
  "signUpLink": "Sign in"
}
